export enum Roles {
  ADMIN = 'ADMIN',
  PARCOURS = 'PARCOURS',
  MODULARISATION = 'MODULARISATION',
  SCENARISATION = 'SCENARISATION',
  REFERENTIEL = 'REFERENTIEL',
  AVANCEMENT = 'AVANCEMENT',
  VALIDATION_PARCOURS = 'VALIDATION_PARCOURS',
}
